var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex"},[_c('h5',[(_vm.icon)?_c('i',{class:`${_vm.icon} mr-1`}):_vm._e(),_vm._v(" "+_vm._s(_vm.caption)+" ")]),(_vm.subcaption)?_c('p',{staticStyle:{"margin":"auto 5px"}},[_vm._v(" ("+_vm._s(_vm.subcaption)+") ")]):_vm._e()]),_c('hr',{staticClass:"mt-0"})])
}
var staticRenderFns = []

export { render, staticRenderFns }